import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../../../core/auto-unsubscribe';
import { RequestProductDto, RequestsXatSvc } from '../../../xatena-api';

@AutoUnsubscribe()
@Injectable({
  providedIn: 'root',
})
export class RequestProductEditDialogService {
  subs = new SubSink();

  key?: {
    requestId?: number;
    requestProductId?: number;
  };

  currency?: string = 'CHF';

  options: FormlyFormOptions = {};
  formFieldAppearance = 'outline';
  form = new FormGroup({});

  model$ = new BehaviorSubject<RequestProductDto | null>(null);

  constructor(private requestService: RequestsXatSvc) {}

  loadProduct(): Observable<void> {
    if (this.key && this.key.requestId && this.key.requestProductId)
      return this.requestService
        .getRequestProduct(this.key.requestId, this.key.requestProductId)
        .pipe(
          map(m => {
            this.model$.next(m);
          })
        );

    this.model$.next({
      requestId: this.key?.requestId,
    } as RequestProductDto);

    return EMPTY;
  }

  saveProduct(dto: RequestProductDto): Observable<any> {
    if (this.key && this.key.requestId) {
      dto.requestId = this.key.requestId;

      const saveProduct$ = this.key.requestProductId
        ? this.requestService.updateRequestProduct(
            this.key.requestId,
            this.key.requestProductId,
            dto
          )
        : this.requestService.createRequestProduct(this.key.requestId, dto);

      return saveProduct$;
    }

    return EMPTY;
  }
}
